import type AttachmentWellViewState from "../schema/AttachmentWellViewState";
import { mutatorAction } from "satcheljs";

export const setSaveAllDialogTargetWindowIdMutator: (attachmentWell: AttachmentWellViewState, targetWindowId: string | undefined) => void = mutatorAction("setSaveAllDialogTargetWindowId", function setSaveAllDialogTargetWindowId(attachmentWell: AttachmentWellViewState, targetWindowId: string | undefined): void {
    attachmentWell.saveAllDialogTargetWindowId = targetWindowId;
});
